import React, { useEffect, useState } from 'react';
import './notifications.css';
import { Icon, Label } from '@nooz-optics/nooz-components-lib';
import { formatContentfulComponentProps } from '../../../utils/globals';
import { Link } from '../../UI/Elements/Link';
import { Image } from '../../UI/Media';
import { List } from '../../UI/Navigation/List/list';

export const Notification = ({ link, body, image }) => {
  const [isHover, setIsHover] = useState(false);
  return (
    <Link {...link}>
      <div
        onMouseEnter={() => setIsHover(true)}
        onMouseLeave={() => setIsHover(false)}
        className='p-6 relative flex justify-between w-full cursor-pointer'>
        <div className='flex items-start'>
          <div className='rounded-md notifications-image w-20 h-20 overflow-hidden'>
            <Image
              {...image}
              height='100%'
              width='100%'
              objectFit='cover'
            />
          </div>
          <div className='ml-4 notifications-text'>
            <Label
              {...link.label}
              weight='medium'
              color={{ classname: 'gray-800' }}
              size='lg'
            />
            <Label
              {...body}
              size='sm'
            />
          </div>
        </div>
        <div className='h-full flex items-center'>
          <div className='bg-red-500 h-4 w-4 rounded-full' />
        </div>
        <div
          className={`${
            isHover ? 'opacity-100' : 'opacity-0'
          } absolute bottom-4 right-5 transform ease-in-out duration-300`}>
          <Icon
            iconKey='MdArrowForward'
            size='2xl'
          />
        </div>
      </div>
    </Link>
  );
};

export const Notifications = ({ details }) => {
  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.localStorage.setItem('has_seen_notifications', true);
    }
  }, []);

  return (
    <div className='h-96 rounded-lg shadow-lg ring-1 bg-white ring-black ring-opacity-5 overflow-scroll no-scrollbar'>
      <div className='relative bg-white'>
        <List
          divide
          listItems={details?.items.map((notification) => ({
            children: (
              <Notification {...formatContentfulComponentProps(notification)} />
            ),
          }))}
        />
      </div>
    </div>
  );
};
